import { useTranslation } from 'react-i18next';
import { ZoomForm } from '../forms/ZoomForm';
import { BigBlueButtonForm } from '../forms/BigBlueButtonForm';
import { ThreemaForm } from '../forms/ThreemaForm';
import { Modal, SpinnerIcon } from '@bp/ui-components';
import { ThreemaBroadcastForm } from '../forms/ThreemaBroadcastForm';
import { BildungsplattformForm } from '../forms/BildungsplattformForm';
import { NextcloudForm } from '../forms/NextcloudForm';
import { LicensedProductTypes } from 'pages/Settings/subpages/types';
import { Suspense } from 'react';

type BookingsModalProps = {
  bookingType: LicensedProductTypes;
  isOpen: boolean;
  onClose: () => void;
};

export const BookingsModal = ({ bookingType, isOpen, onClose }: BookingsModalProps) => {
  const { t } = useTranslation();

  const Form = () => {
    if (bookingType === 'Nextcloud')
      return (
        <Suspense fallback={<SpinnerIcon className={'svg-icon large spinning'} />}>
          <NextcloudForm onClose={onClose} />
        </Suspense>
      );
    else if (bookingType === 'Zoom') return <ZoomForm onClose={onClose} />;
    else if (bookingType === 'BigBlueButton') return <BigBlueButtonForm onClose={onClose} />;
    else if (bookingType === 'Threema') return <ThreemaForm onClose={onClose} />;
    else if (bookingType === 'ThreemaBroadcast') return <ThreemaBroadcastForm onClose={onClose} />;
    else if (bookingType === 'Bildungsplattform') return <BildungsplattformForm onClose={onClose} />;
    // TODO: mailbox.org
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} title={`${t('settings.title')} ${bookingType}`}>
      {Form()}
    </Modal>
  );
};
